module.exports = __webpack_public_path__ + "img/PL10173.8486b734.png";